import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import ContactAPI, { Contact, ContactQueryResponse } from "apis/ContactAPI";
import * as React from "react";

interface ContactForm {
  name: string;
  id: string;
}

interface CustomSelectProps {
  onHandleChange: (selected: ContactForm | null) => void;
}

const AutocompleteInputContact: React.FC<CustomSelectProps> = ({
  onHandleChange,
}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<ContactForm[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");

  const fetchContacts = async (text: string) => {
    if (text.length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);

    try {
      const response = await ContactAPI.query({
        limit: 30,
        page: 0,
        query: { text, order: "name" },
      });
      const resultAPI = response.data as ContactQueryResponse;
      setOptions(
        resultAPI.entities.map((contact: Contact) => ({
          name: contact.name,
          id: contact.id,
        })) || []
      );
    } catch (error) {
      console.error("Erro ao buscar contatos:", error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (searchText.length >= 3) {
      void fetchContacts(searchText);
      return;
    }

    setOptions([]);
  }, [searchText]);

  return (
    <Autocomplete
      id="autocomplete-contacts"
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: "14px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: 2,
          borderColor: "divider",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "primary.main",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "primary.main",
            borderWidth: 2,
          },
        "& .MuiOutlinedInput-input": {
          color: "text.primary",
          fontWeight: 500,
        },
      }}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name}
      options={options}
      noOptionsText="Nenhum contato encontrado"
      loading={loading}
      onChange={(_, value) => onHandleChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Cliente"
          placeholder="Digite ao menos 3 letras"
          onChange={(event) => setSearchText(event.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutocompleteInputContact;
